export default __webpack_public_path__ + "static/media/snake2.ea403116.png";